(() => {
  if (customElements.get('pet-personalized-product')) return;
  class PetPersonalizedProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.files = [];
      this.busy = false;
      this.form = this.querySelector('form');
      this.selects = [...this.querySelectorAll('[data-option-index]')];
      this.buttons = [...this.querySelectorAll('[data-action]')];
      this.message = this.querySelector('[data-message]');
      this.picker = this.querySelector('[data-files]');
      this.error = this.querySelector('[data-error]');
      this.status = this.querySelector('[data-status]');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      const on = (node, type, fn) => {
  if (!node) return;
  node.addEventListener(type, fn, { signal: this.abort.signal });
};
      on(this.form, 'submit', (event) => this.submit(event));
      on(this.message, 'input', () => {
        this.message.setCustomValidity('');
        this.querySelector('[data-counter]').textContent = `${this.message.value.length}/1024`;
      });
      on(this.picker, 'change', () => {
        this.addFiles([...this.picker.files]);
        this.picker.value = '';
      });
      this.selects.forEach(select => on(select, 'change', () => this.updateVariant(true)));
      const dropzone = this.querySelector('[data-dropzone]');
      on(dropzone, 'dragover', (event) => { event.preventDefault(); if (!this.busy) dropzone.classList.add('is-dragging'); });
      on(dropzone, 'dragleave', () => dropzone.classList.remove('is-dragging'));
      on(dropzone, 'drop', (event) => {
        event.preventDefault();
        dropzone.classList.remove('is-dragging');
        if (!this.busy) this.addFiles([...event.dataTransfer.files]);
      });
      on(this, 'click', (event) => {
        const thumbnail = event.target.closest('[data-media-target]');
        if (thumbnail) {
          this.showMedia(thumbnail.dataset.mediaTarget);
        }

        const galleryPrev = event.target.closest('[data-gallery-prev]');
        const galleryNext = event.target.closest('[data-gallery-next]');

        if (galleryPrev || galleryNext) {
          event.preventDefault();

          const thumbs = [...this.querySelectorAll('[data-media-target]')];
          const currentMedia = [...this.querySelectorAll('[data-media-id]')]
            .find(media => !media.hidden);

          let currentIndex = thumbs.findIndex(
            thumb => thumb.dataset.mediaTarget === currentMedia?.dataset.mediaId
          );

          if (currentIndex < 0) currentIndex = 0;

          const direction = galleryPrev ? -1 : 1;
          const nextIndex =
            (currentIndex + direction + thumbs.length) % thumbs.length;

          this.showMedia(thumbs[nextIndex].dataset.mediaTarget);
        }

        const remove = event.target.closest('[data-remove-file]');
        if (remove && !this.busy) {
          const [entry] = this.files.splice(Number(remove.dataset.removeFile), 1);
          URL.revokeObjectURL(entry.url);
          this.renderFiles();
          this.picker.focus();
        }
const zoom = event.target.closest('[data-zoom]');
if (zoom) {
  const source = zoom.querySelector('img');
  const image = this.querySelector('[data-lightbox-image]');
  image.src = source.currentSrc || source.src;
  image.alt = source.alt;
  this.querySelector('[data-lightbox]').showModal();
}
const prev = event.target.closest('[data-lightbox-prev]');
const next = event.target.closest('[data-lightbox-next]');
if (prev || next) {
  const thumbs = [...this.querySelectorAll('[data-media-target]')];
  const visibleMedia = [...this.querySelectorAll('[data-media-id]')]
    .find(media => !media.hidden);

  let index = thumbs.findIndex(
    thumb => thumb.dataset.mediaTarget === visibleMedia?.dataset.mediaId
  );

  if (index === -1) index = 0;

  index = prev
    ? (index - 1 + thumbs.length) % thumbs.length
    : (index + 1) % thumbs.length;

  const targetId = thumbs[index].dataset.mediaTarget;
  const targetMedia = this.querySelector(`[data-media-id="${targetId}"]`);
  const source = targetMedia?.querySelector('img');
  const image = this.querySelector('[data-lightbox-image]');

  if (source) {
    image.src = source.currentSrc || source.src;
    image.alt = source.alt;
    this.showMedia(targetId);
  }
}
const fullscreen = event.target.closest('[data-lightbox-fullscreen]');

if (fullscreen) {
  const lightbox = this.querySelector('[data-lightbox]');
  lightbox.classList.toggle('is-fullscreen');
}
if (event.target.closest('[data-close]')) {
  this.querySelector('[data-lightbox]').close();
}
      });
      const lightbox = this.querySelector('[data-lightbox]');
      on(lightbox, 'click', (event) => { if (event.target === lightbox) lightbox.close(); });
      this.updateVariant(false);
      this.draftReady = this.restoreDraft();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.files?.forEach(entry => URL.revokeObjectURL(entry.url));
      this.initialized = false;
    }

    updateVariant(updateUrl) {
      const choices = this.selects.map(select => select.value);
      // Disable impossible combinations using selections in earlier dropdowns.
      this.selects.forEach((select, index) => {
        [...select.options].forEach(option => {
          if (!option.value) return;
          option.disabled = !this.variants.some(variant => variant.options[index] === option.value &&
            choices.every((value, previous) => previous >= index || !value || variant.options[previous] === value));
        });
        if (select.selectedOptions[0]?.disabled) { select.value = ''; choices[index] = ''; }
      });
      this.variant = this.variants.find(variant => choices.length === 0 ||
        choices.every((value, index) => value && variant.options[index] === value));
      const canBuy = Boolean(this.variant?.available) && !this.busy;
      this.buttons.forEach(button => { button.disabled = this.busy; });
      this.querySelector('[data-variant-id]').value = this.variant?.id || '';

      if (!this.busy) this.status.textContent = this.variant ? (this.variant.available ? '' : 'This option is sold out.') : 'Please select your options.';
       if (this.variant) { 
      this.querySelector('[data-price]').textContent = this.variant.price;
        const compare = this.querySelector('[data-compare]');
        compare.textContent = this.variant.compare || '';
        compare.hidden = !this.variant.compare;
        if (updateUrl && this.variant.mediaId) this.showMedia(String(this.variant.mediaId));
      }
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (this.variant) url.searchParams.set('variant', this.variant.id);
        else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
      }
    }

    showMedia(id) {
      if (![...this.querySelectorAll('[data-media-id]')].some(media => media.dataset.mediaId === id)) return;
      this.querySelectorAll('[data-media-id]').forEach(media => {
        media.hidden = media.dataset.mediaId !== id;
        if (media.hidden) {
          media.querySelectorAll('video').forEach(video => video.pause());
          // Reload only a hidden external player to stop playback.
          media.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
        }
      });
      this.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
    }

    addFiles(incoming) {
      const errors = [];
      const maxCount = Number(this.dataset.maxFiles);
      const maxSize = Number(this.dataset.maxMb) * 1024 * 1024;
      for (const file of incoming) {
        if (this.files.length >= maxCount) { errors.push(`Choose no more than ${maxCount} photos.`); break; }
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) { errors.push(`${file.name}: use JPG, PNG or WebP.`); continue; }
        if (file.size === 0 || file.size > maxSize) { errors.push(`${file.name}: choose a photo under ${this.dataset.maxMb} MB.`); continue; }
        if (this.files.some(entry => entry.file.name === file.name && entry.file.size === file.size && entry.file.lastModified === file.lastModified)) continue;
        this.files.push({ file, url: URL.createObjectURL(file) });
      }
      const uploadError = this.querySelector('[data-upload-error]');
      uploadError.textContent = [...new Set(errors)].join(' ');
      uploadError.hidden = !errors.length;
      this.renderFiles();
    }

    renderFiles() {
      const list = this.querySelector('[data-file-list]');
      list.replaceChildren();
      this.files.forEach((entry, index) => {
        const li = document.createElement('li');
        li.className = 'pp__file';
        const image = document.createElement('img');
        image.src = entry.url;
        image.alt = `Selected photo ${index + 1}`;
        const name = document.createElement('span');
        name.className = 'pp__file-name';
        name.textContent = entry.file.name;
        const size = document.createElement('small');
        size.textContent = `${(entry.file.size / 1024 / 1024).toFixed(2)} MB 路 Ready to upload with your order`;
        name.append(size);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pp__file-remove';
        button.dataset.removeFile = index;
        button.setAttribute('aria-label', `Remove ${entry.file.name}`);
        button.textContent = '×';
        button.disabled = this.busy;
        li.append(image, name, button);
        list.append(li);
      });
      this.querySelector('[data-file-count]').textContent = `${this.files.length} of ${this.dataset.maxFiles} photos selected`;
    }

    setBusy(busy) {
      this.busy = busy;
      this.form.setAttribute('aria-busy', String(busy));
      [...this.selects, this.message, this.picker, ...this.querySelectorAll('[data-remove-file]')].filter(Boolean).forEach(input => { input.disabled = busy; });
      this.buttons.forEach(button => { button.disabled = busy || !this.variant?.available; });
    }

    async submit(event) {
      event.preventDefault();
      await this.draftReady;
      if (this.busy) return;
      this.error.hidden = true;
      this.querySelector('[data-cart-link]').hidden = true;
      if (!this.variant?.available) {
  const missingOption = this.selects.find(select => !select.value);

  if (missingOption) {
    this.showError('Please select a size.');
    missingOption.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    missingOption.focus();
    return;
  }

  this.showError('This option is currently unavailable.');
  return;
}
      if (this.message?.required && !this.message.value.trim()) this.message.setCustomValidity('Please enter your personalization.');
      if (!this.form.reportValidity()) return;
      if (this.dataset.photoRequired === 'true' && !this.files.length) {
  this.showError('Please upload at least one photo.');
  const dropzone = this.querySelector('[data-dropzone]');
  dropzone.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
  return;
}
      const checkout = event.submitter?.dataset.action === 'checkout';
      const payload = new FormData(this.form);
      // Real File objects, not local preview URLs, must be sent to Shopify.
      this.files.forEach((entry, index) => payload.append(`properties[Photo ${index + 1}]`, entry.file, entry.file.name));
      payload.delete('return_to');
      this.setBusy(true);
      this.status.textContent = this.files.length ? 'Uploading your photos and saving your customization...' : 'Saving your customization...';
      let confirmed = false;
      try {
        // Keep the real files locally before navigation; never store preview URLs.
        await this.saveDraft();
        const response = await fetch(this.dataset.addUrl, { method: 'POST', body: payload, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        let result;
        try { result = await response.json(); } catch { throw new Error('The server response could not be confirmed. Check your cart before trying again.'); }
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Shopify could not add this item. Check your cart and try again.');
        confirmed = true;
        this.status.textContent = checkout ? 'Saved. Opening checkout...' : 'Added. Opening your cart...';
        window.location.assign(checkout ? this.dataset.checkoutUrl : this.dataset.cartUrl);
      } catch (error) {
        this.showError(error instanceof TypeError ? 'The connection was interrupted. Check your cart before trying again to avoid adding this item twice.' : error.message);
        this.querySelector('[data-cart-link]').hidden = false;
        this.status.textContent = '';
        if (!confirmed) this.setBusy(false);
      }
    }

    // Drafts are isolated by browser tab and product, and expire after 24 hours.
    // IndexedDB supports File objects without localStorage's small text quota.
    getDraftKey() {
      if (!this.message && !this.picker) return null;
      const slot = 'duonice-customization-tab-v1';
      let tabId = sessionStorage.getItem(slot);
      if (!tabId) {
        tabId = crypto.randomUUID();
        sessionStorage.setItem(slot, tabId);
      }
      return `${tabId}:${window.location.pathname}`;
    }

    openDraftDb() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open('duonice-customization-drafts-v1', 1);
        let expired = false;
        const timer = setTimeout(() => {
          expired = true;
          reject(new Error('Draft storage timed out.'));
        }, 2000);
        request.onupgradeneeded = () => {
          const db = request.result;
          if (!db.objectStoreNames.contains('drafts')) db.createObjectStore('drafts');
        };
        request.onsuccess = () => {
          clearTimeout(timer);
          if (expired) request.result.close();
          else resolve(request.result);
        };
        request.onerror = () => { clearTimeout(timer); reject(request.error); };
      });
    }

    async draftStorage(action, value) {
      let db;
      try {
        const key = this.getDraftKey();
        if (!key) return null;
        db = await this.openDraftDb();
        return await new Promise((resolve, reject) => {
          const transaction = db.transaction('drafts', 'readwrite');
          const store = transaction.objectStore('drafts');
          let result = null;
          const request = action === 'save' ? store.put(value, key) : store.get(key);
          request.onsuccess = () => { if (action !== 'save') result = request.result; };
          // Remove expired photos whenever draft storage is accessed.
          const cursorRequest = store.openCursor();
          cursorRequest.onsuccess = () => {
            const cursor = cursorRequest.result;
            if (!cursor) return;
            if (!cursor.value.expiresAt || cursor.value.expiresAt <= Date.now()) cursor.delete();
            cursor.continue();
          };
          transaction.oncomplete = () => resolve(result);
          transaction.onerror = () => reject(transaction.error);
          transaction.onabort = () => reject(transaction.error);
        });
      } catch {
        // Disabled/private/full browser storage must never block a purchase.
        return null;
      } finally {
        db?.close();
      }
    }

    async saveDraft() {
      return this.draftStorage('save', {
        expiresAt: Date.now() + 24 * 60 * 60 * 1000,
        options: this.selects.map(select => select.value),
        message: this.message?.value || '',
        files: this.files.map(entry => entry.file)
      });
    }

    async restoreDraft() {
      // Avoid overwriting anything the customer enters while storage loads.
      let edited = false;
      const markEdited = () => { edited = true; };
      this.addEventListener('input', markEdited);
      this.addEventListener('change', markEdited);
      this.addEventListener('drop', markEdited);
      try {
        const draft = await this.draftStorage('load');
        if (!this.isConnected || edited || !draft || draft.expiresAt <= Date.now()) return;
        if (Array.isArray(draft.options) && !new URL(window.location.href).searchParams.has('variant')) {
          this.selects.forEach((select, index) => {
            const value = draft.options[index];
            if ([...select.options].some(option => option.value === value)) select.value = value;
          });
          this.updateVariant(false);
        }
        if (this.message && typeof draft.message === 'string') {
          this.message.value = draft.message;
          this.message.setCustomValidity('');
          const counter = this.querySelector('[data-counter]');
          if (counter) counter.textContent = `${this.message.value.length}/1024`;
        }
        if (this.picker && Array.isArray(draft.files) && !this.files.length) {
          this.addFiles(draft.files);
        }
      } catch {
        // A stale draft must not interfere with the product form.
      } finally {
        this.removeEventListener('input', markEdited);
        this.removeEventListener('change', markEdited);
        this.removeEventListener('drop', markEdited);
      }
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
    }
  }
  customElements.define('pet-personalized-product', PetPersonalizedProduct);
})();

